import { NavigationMenuIndicator } from '@radix-ui/react-navigation-menu'
import { cn } from 'utils/cn'

export const Indicator = () => (
  <NavigationMenuIndicator
    className={cn(
      'hidden lg:flex',
      'top-full z-[1] h-[10px] items-end justify-center overflow-hidden',
      'data-[state=visible]:animate-fadeIn data-[state=hidden]:animate-fadeOut transition-[width,transform_250ms_ease]',
    )}
  >
    <div className='bg-surface-primary shadow-menu relative top-[70%] h-[10px] w-[10px] rotate-[45deg] rounded-tl-[2px]' />
  </NavigationMenuIndicator>
)
